/**
 * Contributing Translations Module (Japanese)
 * 
 * @module contributing
 * @language ja
 */

export const contributing = {
  contributing: {
    // Hero Section
    pageTitle: "ユースフューチャーズへの貢献",
    heroSubtitle: "世界的に若者のリーダーシップを理解し、前進させることに専念した共同研究イニシアチブ",
    heroDescription: "私たちは、プラットフォームを強化するデータ、インサイト、専門知識を提供する機関、組織、研究者、会員、コミュニティパートナーを招待しています。",
    
    // Why Contribute Section
    whyContributeTitle: "なぜ貢献するのか？",
    whyContributeSubtitle: "あなたの貢献は、グローバルな若者リーダーシップの理解に真の違いをもたらします",
    
    globalImpact: "グローバルインパクト",
    globalImpactDesc: "あなたのデータは、政策立案者、投資家、世界中のJCI会員、そしてグローバルな若者リーダーシップコミュニティに届き、若いリーダーがどのように育成され、認識されるかに具体的な影響を与えます。",
    
    academicRecognition: "学術的認知",
    academicRecognitionDesc: "技術レポート、科学出版物、国際会議でのプレゼンテーション、コラボレーション証明書、ソーシャルメディアでの認知における正式な引用—学術CV および専門ポートフォリオに有効。",
    
    rigorousMethodology: "厳密な方法論",
    rigorousMethodologyDesc: "すべての貢献は国際基準（国連ガイドライン、学術的ベストプラクティス）に沿っており、あなたの機関と結果に対する最大の信頼性を保証します。",
    
    openAccess: "オープンアクセス",
    openAccessDesc: "すべての発見は、インタラクティブダッシュボード、技術レポート（PDF）、データファイル（CSV/Excel）を通じて公開されており、クリエイティブ・コモンズライセンスの下で非商用利用は無料です。",
    
    formalRecognition: "正式な認知",
    formalRecognitionDesc: "技術レポートとプレゼンテーションでの引用、国際会議とイベントでの言及、デジタルコラボレーション証明書、JCIソーシャルメディアチャンネルでの認知、専門資格として有効。",
    
    // Who Can Contribute Section
    whoCanContributeTitle: "誰が貢献できるか？",
    whoCanContributeSubtitle: "多様な視点が私たちの研究プラットフォームを強化します",
    
    nationalOrgs: "JCI全国組織",
    nationalOrgsDesc: "リーダーシップ開発、会員エンゲージメント、プログラムインパクト、地域イニシアチブに関する戦略データを共有してください。",
    nationalOrgsDetails: "全国会員統計とデモグラフィック、JCI戦略計画2023-2027に沿ったプログラムとプロジェクトの結果、地域リーダーシップのトレンドとインサイト、パートナーシップとコラボレーションの成果、トレーニングと開発の指標、イベント参加とエンゲージメントデータ、戦略的イニシアチブとイノベーション。",
    nationalOrgsWhy: "オブザーバトリーがすべての地域と国にわたるJCIの真の多様性とインパクトを反映するのを助けてください。",
    
    committees: "JCI委員会と評議会",
    committeesDesc: "専門委員会は、リーダーシップ開発の特定の側面に関する専門知識を提供します。",
    committeesDetails: "開発評議会（戦略、運営、教育、インパクト）、評議会固有のデータと指標、ベストプラクティスと方法論、会員開発成果、トレーニングと認定結果、地域パフォーマンス指標。",
    committeesWhy: "オブザーバトリーがすべての戦略的側面でJCIがリーダーを育成する方法についての専門的な視点を提示できるようにしてください。",
    
    individualMembers: "JCI個人会員",
    individualMembersDesc: "すべての会員が共有すべき貴重なインサイトと経験を持っています。",
    individualMembersDetails: "個人的なリーダーシップ開発ストーリー、プログラム参加のフィードバックと成果、スキル開発とトレーニング経験、メンタリングとネットワーキングのインサイト、キャリア向上の例、コミュニティインパクトプロジェクト、データ品質の修正と更新、方法論的提案とフィードバック。",
    individualMembersWhy: "会員の声は、オブザーバトリーがJCI内での実際のリーダーシップの旅と生きた経験を反映することを保証します。",
    
    researchPartners: "研究パートナーと学術機関",
    researchPartnersDesc: "大学、研究センター、学術グループがオリジナルの研究と分析を提供します。",
    researchPartnersDetails: "学術研究論文と研究、JCI会員開発に関する縦断研究、他のリーダーシップ組織との比較分析、方法論的レビューと検証、学生研究プロジェクト、機関マッピングと分析、カリキュラム整合研究、公開されたデータセットと発見。",
    researchPartnersWhy: "学術的パートナーシップは、オブザーバトリーを国際基準に沿った信頼できる研究プラットフォームとして検証します。",
    
    educationalInstitutions: "教育機関とトレーニングセンター",
    educationalInstitutionsDesc: "学校、大学、職業センター、トレーニング組織が教育データを提供します。",
    educationalInstitutionsDetails: "リーダーシップカリキュラムマッピング、JCI会員学生の入学と成果、トレーニングプログラムの結果、スキル開発指標、卒業生の就職データ、パートナーシッププログラムの結果、JCIフレームワークとのコース整合、認定と資格データ。",
    educationalInstitutionsWhy: "教育データは、JCIリーダーシップ開発が学術的および専門的な向上にどのように変換されるかを明らかにします。",
    
    governmentNgos: "政府、NGO、機関パートナー",
    governmentNgosDesc: "政府機関、国際組織、市民社会パートナーが戦略データを提供します。",
    governmentNgosDetails: "JCIイニシアチブとの公共政策の整合、政府パートナーシップの成果、国際組織とのコラボレーションデータ、NGOパートナーシップの有効性、コミュニティインパクト指標、持続可能性と社会的責任データ、機関の認識と承認、規制とフレームワークの整合。",
    governmentNgosWhy: "機関パートナーシップは、JCIの信頼性とグローバル開発アジェンダとの整合を示します。",
    
    // How to Contribute Section
    howToContributeTitle: "貢献方法",
    howToContributeSubtitle: "必要な情報とともにメールで貢献を提出してください",
    
    contributionFormTitle: "貢献フォーム",
    contributionFormDesc: "フォームを使用して貢献を提出してください。すべてのフィールドが必須です。",
    sendTo: "情報は次のアドレスに送信されます：",
    
    yourInformation: "あなたの情報",
    fullName: "氏名",
    fullNameDesc: "あなたの完全な名前",
    affiliatedOrg: "所属組織",
    affiliatedOrgDesc: "全国組織、委員会、機関、会社など",
    emailAddress: "メールアドレス",
    emailAddressDesc: "連絡先",
    yourRole: "役職",
    yourRoleDesc: "組織での役職/機能",
    
    contributionDetails: "貢献の詳細",
    contributionType: "貢献タイプ",
    contributionTypeDesc: "カテゴリを選択：研究データ、プログラム結果、会員インサイト、機関パートナーシップ、トレーニング成果、戦略分析、品質改善、その他",
    contributionDescription: "貢献の説明",
    contributionDescriptionDesc: "提供する内容とその関連性を簡潔に説明してください（最低20文字）",
    dataFormat: "データ形式",
    dataFormatDesc: "データはどのように利用可能ですか？（Excel、PDF、科学論文、リンク、データベース、レポート、その他）",
    dataScope: "データの範囲",
    dataScopeDesc: "地理的範囲と対象期間",
    verificationStatus: "検証状況",
    verificationStatusDesc: "このデータは検証済み/監査可能ですか？はい/いいえ",
    
    authorization: "承認とコミットメント",
    citationAuth: "すべての公開資料において正式な出典帰属とともにJCIオブザーバトリーで提供されたデータの使用を許可します",
    dataOwnership: "私の組織がこのデータを所有しているか、共有する許可を持っていることを確認します",
    accuracy: "提供されたデータが正確であり、利用可能な最良の情報を表すことを証明します",
    required: "必須",
    
    // Contribution Process Section
    processTitle: "貢献プロセス",
    processSubtitle: "提出から公開まで2〜4週間",
    
    step1: "連絡と提出",
    step1Desc: "完成したフォームとともにメールで提案を提出",
    step2: "初期レビュー",
    step2Desc: "私たちのチームが関連性、品質、JCIの価値観と方法論との整合性を評価",
    step3: "データ検証",
    step3Desc: "統合前にデータソース、方法論、正確性を検証",
    step4: "統合",
    step4Desc: "データとインサイトがオブザーバトリープラットフォームに組み込まれる",
    step5: "正式な認知",
    step5Desc: "あなたの貢献は正式な引用、証明書、公的な謝辞を受ける",
    
    timeline: "タイムライン：提出から公開まで2〜4週間",
    
    // Our Commitments Section
    commitmentsTitle: "私たちのコミットメント",
    commitmentsSubtitle: "すべての貢献者への約束",
    
    transparencyProtocol: "透明性プロトコル",
    transparencyProtocolDesc: "すべての貢献において完全な透明性を維持：完全なクレジットで引用されたすべてのソース、明確に識別された組織と貢献者の名前、文書化された作業/データセットのタイトルと公開日、利用可能な場合は完全なリンクとDOI、完全な参考文献、説明された方法論と計算式、明確に述べられたデータの制限。すべての貢献は追跡可能で監査可能です。",
    
    openMethodology: "オープンな方法論",
    openMethodologyDesc: "オブザーバトリーは完全な方法論的透明性で運営：文書化されたすべてのフレームワークと指標、完全に説明された計算方法論、公開学術監査に利用可能、完全な詳細を含む技術レポート、すべての数式を含む計算シート、方法論の質問に対応するFAQ、定期的な方法論レビューと更新。私たちが公開するすべてを検証できます。",
    
    formalRecognitionCommitment: "正式な認知",
    formalRecognitionCommitmentDesc: "貢献者は包括的な認知を受ける：すべての技術レポートと出版物での引用、JCI国際会議でのプレゼンテーションでの言及、デジタルコラボレーション証明書（ダウンロード可能）、JCIソーシャルメディアチャンネルでの認知、オブザーバトリー「貢献者」セクションでの紹介、特別研究の共著への招待、新しいオブザーバトリーデータセットへの優先アクセス。あなたの貢献は機関の信頼性を高めます。",
    
    publicAccess: "パブリックアクセス",
    publicAccessDesc: "すべてのオブザーバトリーデータとインサイトは無料で利用可能：インタラクティブオンラインダッシュボード、PDF形式の技術レポート、CSV/Excel形式のデータファイル、クリエイティブ・コモンズ BY-NC-SA 4.0 ライセンス、非商用学術使用は無料、リクエストに応じて商用ライセンス利用可能、登録研究パートナー向けAPIアクセス。あなたのインサイトはグローバルな聴衆に届きます。",
    
    dataQualityStandards: "データ品質基準",
    dataQualityStandardsDesc: "厳格なデータ品質慣行を維持：すべてのデータは検証済みで監査可能である必要がある、明確な表記なしに合成または推定データは不可、ソースは公開されて文書化されている必要がある、方法論は再現可能である必要がある、公開前にデータ精度を検証、定期的な品質監査とレビュー、エラーの修正手順。卓越性は譲れない。",
    
    // Contribution Types Section
    contributionTypesTitle: "貢献タイプと例",
    contributionTypesSubtitle: "オブザーバトリーに貢献するさまざまな方法",
    
    researchData: "研究データ",
    researchDataExamples: "若者リーダーシップに関する学術研究論文、会員開発に関する縦断研究、同業組織との比較分析、調査結果と統計分析",
    
    programResults: "プログラム結果",
    programResultsExamples: "JCIプログラム成果指標、プロジェクトインパクト評価、トレーニング完了と認定データ、会員エンゲージメントと継続率統計",
    
    memberInsights: "会員インサイト",
    memberInsightsExamples: "会員デモグラフィックデータ、キャリア向上の例、リーダーシップスキル開発ストーリー、メンタリングプログラムの成果",
    
    institutionalPartnerships: "機関パートナーシップ",
    institutionalPartnershipsExamples: "パートナーシップ有効性データ、コラボレーション成果、共同プログラム結果、機関の承認",
    
    trainingOutcomes: "トレーニング成果",
    trainingOutcomesExamples: "トレーニングプログラム指標、認定データ、スキル開発評価、教育整合分析",
    
    strategicAnalysis: "戦略分析",
    strategicAnalysisExamples: "地域トレンドとインサイト、セクター固有の分析、ベストプラクティス文書化、イノベーションケーススタディ",
    
    qualityImprovements: "品質改善",
    qualityImprovementsExamples: "データの修正と更新、方法論的提案、欠落情報の特定、プロセス改善の推奨",
    
    // Data Requirements Section
    dataRequirementsTitle: "データ要件",
    dataRequirementsSubtitle: "貢献が受け入れられるために、以下を確認してください：",
    
    mandatoryElements: "必須要素",
    mandatoryList: "明確なデータソースの識別、対象期間（日付範囲）、地理的範囲（地域、国、グローバル）、データ収集方法論、サンプルサイズ（該当する場合）、検証声明、共有許可声明",
    
    recommendedElements: "推奨要素",
    recommendedList: "質問用の連絡担当者、サポート文書、関連研究または参考文献、制限または注意事項、推奨される使用法/解釈、相互参照用の関連データセット、更新頻度（繰り返しの場合）",
    
    // FAQ Section
    faqTitle: "よくある質問",
    faqSubtitle: "オブザーバトリーへの貢献に関する一般的な質問",
    
    faq1Q: "貢献プロセスにはどのくらい時間がかかりますか？",
    faq1A: "通常、提出から公開まで2〜4週間ですが、データの複雑さと必要な検証ステップによって異なります。",
    
    faq2Q: "私の組織はクレジットされますか？",
    faq2A: "はい、もちろんです。すべての貢献は、表示されるすべての出版物で正式な引用を受けます。",
    
    faq3Q: "機密データを提供できますか？",
    faq3A: "一般的にはいいえ—オブザーバトリーは公開されて検証可能なデータを必要とします。ただし、集計または匿名化されたデータは可能かもしれません。特定の状況について話し合うためにお問い合わせください。",
    
    faq4Q: "オブザーバトリーを使用するためにデータを提供する必要がありますか？",
    faq4A: "いいえ。オブザーバトリーは無料で誰でも利用できます。貢献は任意で歓迎されますが、必須ではありません。",
    
    faq5Q: "データにエラーを見つけた場合はどうなりますか？",
    faq5A: "修正手順があります。すぐにお問い合わせください。データを更新し、正誤表を公開します。",
    
    faq6Q: "貢献を更新できますか？",
    faq6A: "はい。年次更新が推奨されます。明確なバージョン履歴とともにいつでも更新されたデータを提出してください。",
    
    faq7Q: "貢献にはコストがかかりますか？",
    faq7A: "いいえ。貢献は任意です。あなたの専門知識とインサイトを大切にしています。",
    
    // Team & Contact Section
    teamTitle: "私たちのチーム",
    teamSubtitle: "貢献の旅を始めるためにお問い合わせください",
    
    observatoryTeam: "JCIオブザーバトリーチーム",
    dashcityTeam: "Dashcityチーム",
    email: "メール",
    website: "ウェブサイト",
    contactForm: "お問い合わせフォーム",
    
    developmentCouncils: "開発評議会の調整",
    strategicCouncil: "戦略開発評議会",
    operationalCouncil: "運営開発評議会",
    educationalCouncil: "教育開発評議会",
    impactCouncil: "インパクト開発評議会",
    
    // Our Commitments to You Section
    partnershipTitle: "あなたへのコミットメント",
    partnershipSubtitle: "JCIオブザーバトリーに貢献すると、以下と提携します：",
    
    commitment1: "100年以上の歴史と120カ国での存在を持つグローバルな若者リーダーシップ組織",
    commitment2: "国連持続可能な開発目標と国際的なベストプラクティスに沿ったデータ駆動型機関",
    commitment3: "厳格な方法論と透明なプロセスに基づいて構築された信頼できる研究プラットフォーム",
    commitment4: "多様な視点と声を大切にする包括的なコミュニティ",
    commitment5: "若いリーダーの育成と認識の方法を変革する成長中のムーブメント",
    
    // Why Your Data Matters Section
    whyDataMattersTitle: "あなたのデータが重要な理由",
    whyDataMattersSubtitle: "JCIオブザーバトリーは重要な質問に答えるために存在します：",
    
    question1: "若いリーダーはグローバルにどのように育成されていますか？",
    question2: "将来のリーダーにとって最も重要なスキルは何ですか？",
    question3: "JCIは会員の生活をどのように変えていますか？",
    question4: "持続可能なリーダーシップインパクトを生み出すものは何ですか？",
    question5: "メンタリング、トレーニング、コミュニティはどのようにリーダーを形成しますか？",
    
    dataMattersConclusion: "あなたの貢献は、実際のデータ、実際の経験、実際のインパクトでこれらの質問に答えるのに役立ちます。一緒に、若者リーダーシップ開発を理解するための権威あるプラットフォームを構築しています。",
    
    // CTA Section
    ctaTitle: "貢献する準備はできましたか？",
    ctaSubtitle: "3つの簡単なステップ",
    
    ctaStep1: "貢献の詳細をフォームに記入",
    ctaStep2: "サポートファイルと一緒にtmariano@jci.ccに送信",
    ctaStep3: "確認をお待ちください - 5営業日以内にチームが連絡します",
    
    questionsTitle: "始める前に質問がありますか？",
    questionsContact: "メールでお問い合わせ：observatory@jci.cc",
    questionsAlternative: "または、全国組織を通じて地域開発評議会の代表者にお問い合わせください。",
    
    startContributing: "貢献を始める",
    contactUs: "お問い合わせ",
    
    // Checklist
    checklistTitle: "貢献チェックリスト",
    checklistSubtitle: "提出前に以下を確認してください：",
    
    checkItem1: "貢献者情報が完全",
    checkItem2: "貢献タイプが明確に選択されている",
    checkItem3: "データソースの文書化",
    checkItem4: "期間と地理的範囲が定義されている",
    checkItem5: "検証/監査声明",
    checkItem6: "共有の許可",
    checkItem7: "サポートファイルの準備",
    checkItem8: "フォローアップ用の連絡先情報",
    
    // Footer info
    lastUpdated: "最終更新：2025年12月",
    availableLanguages: "英語、ポルトガル語、スペイン語、フランス語、日本語で利用可能",
    joinCommunity: "若者リーダーシップ研究の未来を構築する貢献者コミュニティに参加しましょう！",
  },
} as const;
